import { TUTORIAL_TOGGLE_TUTORIAL_MODAL } from './constants';

export function toggleTutorialModal() {
  return {
    type: TUTORIAL_TOGGLE_TUTORIAL_MODAL,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case TUTORIAL_TOGGLE_TUTORIAL_MODAL:
      return {
        ...state,
        toggleTutorialModal: !state.toggleTutorialModal,
      };

    default:
      return state;
  }
}
